import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';
import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      width: '100%',
      height: 'calc(100vh - 116px)',
      display: 'grid',
      gridTemplateColumns: '1fr minmax(420px, 30%)',
      backgroundColor: DARK_MUTED.darkmuted600,
    },
  },
};
